var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('img',{staticClass:"rotate",attrs:{"alt":"spinner","src":require("@/assets/Load.svg")},on:{"animationstart":_vm.rotateStart,"animationiteration":_vm.rotateIteration}})])}
var staticRenderFns = []

export { render, staticRenderFns }